export function formatRuntime(runtime: number): string {
  const hours = Math.floor(runtime / 60);
  const minutes = Math.floor(runtime % 60);

  if (hours > 0) {
    if (minutes === 0) {
      return `${hours} hr`;
    }
    return `${hours} hr ${minutes} min`;
  }
  return `${minutes} min`;
}

// Format 1:12:34
export function formatRuntimeSeconds(runtimeSeconds: number): string {
  const h = Math.floor(runtimeSeconds / 3600);
  const m = Math.floor((runtimeSeconds % 3600) / 60);
  const s = runtimeSeconds % 60;

  return `${h > 0 ? `${h}:` : ""}${h > 0 ? `${String(m).padStart(2, "0")}` : m}:${String(s).padStart(2, "0")}`;
}